import { render, staticRenderFns } from "./ReviewYourAnswersFS.vue?vue&type=template&id=4b27269d"
import script from "./ReviewYourAnswersFS.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports